"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCodes = void 0;
const ISO_3166_1_alpha_2_codes_1 = require("./ISO_3166_1_alpha_2_codes");
const ISO_3166_1_alpha_2_frenchDROMCodes_1 = require("./ISO_3166_1_alpha_2_frenchDROMCodes");
const ISO_3166_1_alpha_2_unsupportedCodes_1 = require("./ISO_3166_1_alpha_2_unsupportedCodes");
exports.countryCodes = ISO_3166_1_alpha_2_codes_1.ISO_3166_1_alpha_2_codes.filter((countryCode) => ![
    ...ISO_3166_1_alpha_2_frenchDROMCodes_1.ISO_3166_1_alpha_2_frenchDROMCodes,
    ...ISO_3166_1_alpha_2_unsupportedCodes_1.ISO_3166_1_alpha_2_unsupportedCodes,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
].includes(countryCode));
